<h2 mat-dialog-title>
  {{ data.id ? 'Edit Organisation' : 'Add Organisation' }}
</h2>
<form (ngSubmit)="onSubmit()" #orgForm="ngForm" autocomplete="off">
  <mat-dialog-content>
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Name</mat-label>
      <input matInput name="name" [(ngModel)]="data.name" required />
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%; margin-top: 16px;">
      <mat-label>Type</mat-label>
      <mat-select name="typeId" [(ngModel)]="data.typeId">
        <mat-option [value]="null">None</mat-option>
        <mat-option *ngFor="let type of organizationTypes" [value]="type.id">
          {{ type.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%; margin-top: 16px;" *ngIf="isAllUnitedType()">
      <mat-label>AllUnited Section</mat-label>
      <input matInput name="allunitedSection" [(ngModel)]="data.allunitedSection" required />
      <mat-error>AllUnited Section is required</mat-error>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button">Cancel</button>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="!data.name || (isAllUnitedType() && !data.allunitedSection)"
    >
      Save
    </button>
  </mat-dialog-actions>
</form>
